/**
 * 补充旅客信息
 */

import { saveOldLocation } from '../../modules/actions';
import { gspCollect } from '@csair/emp-helpers';
import { loadStatusCodeMsg } from 'enEXchange';

export default store => ({
  path: 'AddPersonMessage',
  onEnter(nextState, replace, callback) {
    loadStatusCodeMsg(['getNameAndPhone', 'change', 'getVerificationCode']);
    gspCollect(
      [
        '2021-EMP退改-补充旅客信息页面',
        '补充旅客信息页面',
        '018-000-71001-103',
      ],
      { 6: '国内' },
      process.env.NODE_ENV === 'production'
    );
    callback();
  },
  onLeave(prevState) {
    store.dispatch(saveOldLocation(prevState.location));
  },
  getComponent(nextState, cb) {
    require.ensure(
      [],
      require => {
        const addPersonMessage = require('./components/addPersonMessage')
          .default;
        cb(null, addPersonMessage);
      },
      'addPersonMessage'
    );
  },
});



// WEBPACK FOOTER //
// ./src/routes/routes/addPersonMessage/index.js